import { pickTypesSettings } from "../tableEditorHeaderHelper.js";
const _ = require("lodash");

export class UptFile {
  constructor() {
    this.header = {};
    this.xmlData = {};
    this.pickData = {};
  }

  setUptFile({ header, xmlData, pickData }) {
    this.header = header;
    this.xmlData = xmlData;
    this.pickData = pickData;
  }

  reset() {
    this.header = {};
    this.xmlData = {};
    this.pickData = {};
  }

  createNewUptFile(numberOfPicks, numberOfJacquardHooks, numberOfShafts) {
    this.header = {
      numberOfHooks: 65535,
      numberOfPicks: 0,
      bytesPerPick: 0,
      weaveType: 128,
      xmlLength: 0
    };
    this.xmlData = {
      patternCreator: "MUENET Editor v0.1",
      parentFileName: "ParentFile",
      patternPicksCount: numberOfPicks,
      pickDataCrypted: 0,
      patternCryptVersion: 2,
      pickTags: [
        { PickDensityPer100m: { bitCount: 32 } },
        { MainSpeed: { bitCount: 16 } },
        { WeftTransportCmm: { bitCount: 16, MapsToBar: "0" } },
        { BinderTransport: { bitCount: 16 } },
        { WarpTransportGear: { bitCount: 16, MapsToBar: "0" } }
      ],
      totalPickBitCount: 96
    };
    this.pickData = {
      jacquardData: {
        tagNames: [],
        data: []
      },
      shaftData: {
        tagNames: [],
        data: []
      },
      driveData: {
        tagNames: [
          "PickDensityPer100m",
          "MainSpeed",
          "WeftTransportCmm",
          "BinderTransport",
          "WarpTransportGear"
        ],
        data: []
      },
      colorControl: {
        tagNames: [],
        data: [],
        colorControlAmount: 32
      }
    };

    if (numberOfShafts) {
      this.xmlData.pickTags.unshift({
        ShaftData: { bitCount: numberOfShafts * 2 }
      });
      const shaftData = new Array(numberOfShafts).fill(0);
      this.pickData.shaftData.tagNames.unshift("ShaftData");
      for (let i = 0; i < numberOfPicks; i++) {
        this.pickData.shaftData.data.push([...shaftData]);
      }
    }

    if (numberOfJacquardHooks) {
      const jacquardBytes = Math.ceil(numberOfJacquardHooks / 8);
      this.xmlData.pickTags.unshift({
        JacquardData: { bitCount: jacquardBytes * 8 }
      });
      this.pickData.jacquardData.tagNames.unshift("JacquardData");
      for (let i = 0; i < numberOfPicks; i++) {
        this.pickData.jacquardData.data.push(
          new Array(jacquardBytes * 8).fill(0)
        );
      }
    }

    const defaultValues = [];
    this.pickData.driveData.tagNames.forEach(tagName => {
      defaultValues.push(pickTypesSettings[tagName].typeSetting.defaultValue);
    });
    for (let i = 0; i < numberOfPicks; i++) {
      this.pickData.driveData.data.push([...defaultValues]);
    }
  }

  addDrive(pickTypeSetting) {
    this.pickData.driveData.tagNames.push(pickTypeSetting.name);
    this.pickData.driveData.data.forEach(pick => {
      pick.push(pickTypeSetting.typeSetting.defaultValue);
    });
    const xmlPickTag = {};
    xmlPickTag[pickTypeSetting.name] = {};
    if (pickTypeSetting.bitCount !== undefined) {
      xmlPickTag[pickTypeSetting.name].bitCount = pickTypeSetting.bitCount;
    }
    if (pickTypeSetting.mapsToBar !== undefined) {
      xmlPickTag[pickTypeSetting.name].MapsToBar = pickTypeSetting.mapsToBar;
    }
    this.xmlData.pickTags.push(xmlPickTag);
  }

  removeDrive(driveIndex) {
    let xmlDriveIndex =
      driveIndex +
      this.xmlData.pickTags.length -
      this.pickData.driveData.tagNames.length;

    this.pickData.driveData.tagNames.splice(driveIndex, 1);
    this.pickData.driveData.data.forEach(pick => {
      pick.splice(driveIndex, 1);
    });

    this.xmlData.pickTags.splice(xmlDriveIndex, 1);
  }

  moveDrives(fromIndex, toIndex) {
    this.pickData.driveData.tagNames.splice(
      toIndex,
      0,
      this.pickData.driveData.tagNames.splice(fromIndex, 1)[0]
    );

    this.pickData.driveData.data.forEach(pick => {
      pick.splice(toIndex, 0, pick.splice(fromIndex, 1)[0]);
    });

    let xmlFromIndex =
      fromIndex +
      this.xmlData.pickTags.length -
      this.pickData.driveData.tagNames.length;
    let xmlToIndex =
      toIndex +
      this.xmlData.pickTags.length -
      this.pickData.driveData.tagNames.length;
    this.xmlData.pickTags.splice(
      xmlToIndex,
      0,
      this.xmlData.pickTags.splice(xmlFromIndex, 1)[0]
    );
  }

  insertPicks(index, quantity) {
    const insertAtEnd = index > this.xmlData.patternPicksCount;
    this.xmlData.patternPicksCount += quantity;

    if (!_.isEmpty(this.pickData.driveData.data)) {
      const indexToCopyFrom = _.clamp(
        index,
        0,
        this.pickData.driveData.data.length - 1
      );
      const drivePick = this.pickData.driveData.data[indexToCopyFrom];
      const picksToInsert = Array(quantity).fill(drivePick);
      const dereferencedPicks = picksToInsert.map(p => [...p]);
      if (insertAtEnd) {
        this.pickData.driveData.data.push(...dereferencedPicks);
      } else {
        this.pickData.driveData.data.splice(index, 0, ...dereferencedPicks);
      }
    }

    if (!_.isEmpty(this.pickData.jacquardData.data)) {
      const indexToCopyFrom = _.clamp(
        index,
        0,
        this.pickData.jacquardData.data.length - 1
      );
      const jacquardPick = this.pickData.jacquardData.data[indexToCopyFrom];
      const picksToInsert = Array(quantity).fill(
        new Array(jacquardPick.length).fill(0)
      );
      const dereferencedPicks = picksToInsert.map(p => [...p]);
      if (insertAtEnd) {
        this.pickData.jacquardData.data.push(...dereferencedPicks);
      } else {
        this.pickData.jacquardData.data.splice(index, 0, ...dereferencedPicks);
      }
    }

    if (!_.isEmpty(this.pickData.shaftData.data)) {
      const indexToCopyFrom = _.clamp(
        index,
        0,
        this.pickData.shaftData.data.length - 1
      );
      const shaftPick = this.pickData.shaftData.data[indexToCopyFrom];
      const picksToInsert = Array(quantity).fill(
        new Array(shaftPick.length).fill(0)
      );
      const dereferencedPicks = picksToInsert.map(p => [...p]);
      if (insertAtEnd) {
        this.pickData.shaftData.data.push(...dereferencedPicks);
      } else {
        this.pickData.shaftData.data.splice(index, 0, ...dereferencedPicks);
      }
    }

    if (!_.isEmpty(this.pickData.colorControl.data)) {
      const indexToCopyFrom = _.clamp(
        index,
        0,
        this.pickData.colorControl.data.length - 1
      );
      const shaftPick = this.pickData.colorControl.data[indexToCopyFrom];
      const picksToInsert = Array(quantity).fill(shaftPick);
      const dereferencedPicks = picksToInsert.map(p => [...p]);
      if (insertAtEnd) {
        this.pickData.colorControl.data.push(...dereferencedPicks);
      } else {
        this.pickData.colorControl.data.splice(index, 0, ...dereferencedPicks);
      }
    }
  }

  deletePicks(index, quantity) {
    this.xmlData.patternPicksCount -= quantity;
    if (this.pickData.driveData.data.length !== 0) {
      this.pickData.driveData.data.splice(index, quantity);
    }
    if (this.pickData.jacquardData.data.length !== 0) {
      this.pickData.jacquardData.data.splice(index, quantity);
    }
    if (this.pickData.shaftData.data.length !== 0) {
      this.pickData.shaftData.data.splice(index, quantity);
    }
    if (this.pickData.colorControl.data.length !== 0) {
      this.pickData.colorControl.data.splice(index, quantity);
    }
  }

  deletePicksFromSelection(indexes) {
    this.xmlData.patternPicksCount -= indexes.length;
    const sortedIndexes = indexes.sort((a, b) => b - a);
    sortedIndexes.forEach(index => {
      if (this.pickData.driveData.data.length !== 0) {
        this.pickData.driveData.data.splice(index, 1);
      }
      if (this.pickData.jacquardData.data.length !== 0) {
        this.pickData.jacquardData.data.splice(index, 1);
      }
      if (this.pickData.shaftData.data.length !== 0) {
        this.pickData.shaftData.data.splice(index, 1);
      }
      if (this.pickData.colorControl.data.length !== 0) {
        this.pickData.colorControl.data.splice(index, 1);
      }
    });
  }
}

const uptFile = new UptFile();

export default uptFile;
